import React from "react";
import { Row } from "react-bootstrap";
import "../components/style/FilterationBarContainer.scss";

function FilterationBarContainer(props) {
  const { children, className } = props;
  return className ? (
    //if class name is passed
    <Row className={`filterBar ${className}`}>{children}</Row>
  ) : (
    //if class name is not passed
    <Row className="filterBar">{children}</Row>
  );
}

export default FilterationBarContainer;
